import endPoints from '../endPoints/EndPoints.json';

export default function getBaseUrl() {
  switch (process.env.REACT_APP_ENVIROMENT) {
    case 'PRODUCTION':
      return endPoints.BASEURL;
    default:
      return endPoints.BASEURLDEV;
  }
};
